import React, { useState } from 'react'
import { Layout } from 'antd'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { BreadcrumbNav } from './BreadcrumbNav'
import { EnvironmentBanner } from './EnvironmentBanner'
import { config } from '../config/env'

const { Content, Footer } = Layout

export const MainLayout: React.FC = () => {
    const [collapsed, setCollapsed] = useState(false)
    const env = config.app.environment
    const showBanner = env !== 'production'

    return (
        <Layout style={{ minHeight: '100vh', paddingTop: showBanner ? '28px' : '0' }}>
            <EnvironmentBanner />
            <Sidebar collapsed={collapsed} />
            <Layout style={{ marginLeft: collapsed ? 80 : 200, transition: 'all 0.2s' }}>
                <Header collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
                <Content
                    style={{
                        margin: '16px 16px',
                        padding: '16px 24px',
                        minHeight: 280,
                        background: '#fff',
                        borderRadius: 8,
                    }}
                >
                    <BreadcrumbNav />
                    <Outlet />
                </Content>
                <Footer style={{ textAlign: 'center', background: '#fff' }}>
                    BID Admin Portal ©{new Date().getFullYear()} | v{config.app.version}
                </Footer>
            </Layout>
        </Layout>
    )
}
